<div class="spinner">
  <mat-spinner></mat-spinner>
  <span>{{message || data?.message || 'Aguarde'}}</span>
</div>